<template>
    <v-container class="px-0 py-3">
        <v-row class="font14">
            <v-col
                class="text-start py-0 pr-0"
                :class="[eventStats.time === 'FT' ? 'ft-stats' : numbersClass, valueOne > valueTwo ? 'bold' : '']"
                style="min-width: 40px; max-width: 40px"
            >
                {{ getValue(valueOne) }}
            </v-col>
            <v-col class="text-center py-0">{{ headerText }}</v-col>
            <v-col
                class="text-end py-0 pl-0 orangeText"
                :class="[eventStats.time === 'FT' ? 'ft-stats' : numbersClass, valueTwo > valueOne ? 'bold' : '']"
                style="min-width: 40px; max-width: 40px"
            >
                {{ getValue(valueTwo) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-start pt-0 pb-1 pr-1">
                <v-progress-linear
                    :value="Math.ceil((valueOne / (valueOne + valueTwo)) * 100)"
                    reverse
                    :background-color="backgroundColor"
                    :color="valueOne >= valueTwo ? filledDarkerColor : filledColor"
                    height="10"
                    rounded
                ></v-progress-linear>
            </v-col>
            <v-col class="text-start pt-0 pb-1 pl-1">
                <v-progress-linear
                    :value="Math.ceil((valueTwo / (valueOne + valueTwo)) * 100)"
                    :background-color="backgroundColor"
                    :color="valueTwo >= valueOne ? filledDarkerColor : filledColor"
                    height="10"
                    rounded
                ></v-progress-linear>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped>
    .ft-stats {
        color: #545454;
    }

    .theme--dark .ft-stats {
        color: #b5bac1;
    }
    .orangeDarkText {
        color: #b3772a;
    }
</style>

<script>
    export default {
        name: 'app-eventStatsRow',
        props: {
            headerText: {
                default: undefined,
                type: String,
            },
            valueOne: {
                default: undefined,
                type: Number,
            },
            numbersClass: {
                default: 'orangeText',
                type: String,
            },
            valueTwo: {
                default: undefined,
                type: Number,
            },
            withPercent: {
                default: false,
                type: Boolean,
            },
            filledColor: {
                default: undefined,
                type: String,
            },
            filledDarkerColor: {
                default: undefined,
                type: String,
            },
            backgroundColor: {
                default: undefined,
                type: String,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {};
        },

        methods: {
            getValue: function (value) {
                if (value && this.withPercent) {
                    value = value + '%';
                }

                return value;
            },
        },
        computed: {
            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },
        },
    };
</script>
